export default "__VITE_ASSET__C5r7xpoJ__"